/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import Swiper, { Autoplay, Navigation, Parallax, Scrollbar } from "swiper";
import Vivus from "vivus";

// FRAMEWORKS : GSAP BUSINESS
import "../js/gsap-business-green/gsap.min.js";
import "../js/gsap-business-green/EasePack.min.js";
import "../js/gsap-business-green/ScrollSmoother.min.js";
import "../js/gsap-business-green/ScrollTrigger.min.js";
import "../js/gsap-business-green/ScrollToPlugin.min.js";
import { SplitText } from "../js/gsap-business-green/SplitText.min.js";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Smooth scrolling par défaut
let scrollSmooth = false;

// GSAP - Activation du scrollSmoother (avec le plugin ScrollSmoother)
scrollSmooth = ScrollSmoother.create({
	wrapper: "#page-wrapper",
	content: "#page-main",
	smooth: 1,
	smoothTouch: false,
	effects: true,
	normalizeScroll: false,
	ignoreMobileResize: true,
});

// Élèment à animer (en CSS ou JS)
const elementsToAnimatedFirst = document.querySelectorAll([
	// global
	"header [data-animation]",
	// elementor
]);
const elementsToAnimatedSecond = document.querySelectorAll([
	// global
	"[data-animation]:not(header [data-animation])",
	// elementor
	".page__article .elementor-heading-title",
	".page__article .elementor-element > .elementor-element > .elementor-element:not([data-animation])",
]);
const textsToAnimated = document.querySelectorAll([
	// global
	"[data-animation='reveal-text']",
	".page__article .elementor-heading-title",
]);

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'no-js' body class
	document.body.classList.remove("no-js");
	gsapPreLoader();
	headerScrolledMenu(160);
	headerMobileMenu();
	menuItemDropdown();
	bannerClosing();
	bannerScrollingDetect();
	popupInit();
	toggleInit();
	allSwiperInit();
	allVivusInit();
	// sessionStorage.setItem("visited", true);
});

// DOCUMENT RESIZED (avec le plugin ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerScrollingDetect();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Global : Activation/désactivation du scroll
function scrollEnabled(bool) {
	if (scrollSmooth) {
		if (bool == false) {
			// Bloquer le scroll
			scrollSmooth.paused(true);
		}
		if (bool == true) {
			// Activer le scroll
			scrollSmooth.paused(false);
		}
	} else {
		if (bool == false) {
			// Bloquer le scroll
			document.documentElement.style.overflowY = "hidden";
		}
		if (bool == true) {
			// Activer le scroll
			document.documentElement.style.overflowY = "auto";
		}
	}
}

// Global : Détection du scroll
function headerScrolledMenu(scrollOffset) {
	let position = window.pageYOffset;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// detect scroll direction
		let scroll = window.pageYOffset;
		if (scroll > position) {
			// if scroll to bottom
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// if scroll to top
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// if scroll max reached
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
}

// Menu Burger : Action au clic
function headerMobileMenu() {
	const pageHeaderBurger = document.querySelector(
		"#page-header #page-header-burger"
	);
	const pageHeader = document.querySelector("#page-header");

	pageHeaderBurger.addEventListener("click", () => {
		if (pageHeader.classList.contains("page__header--open")) {
			// Fermer le menu au clic sur le bouton burger
			scrollEnabled(true);
			pageHeader.classList.remove("page__header--open");
		} else {
			// Ouvrir le menu au clic sur le bouton burger
			scrollEnabled(false);
			pageHeader.classList.add("page__header--open");
		}
	});

	document.addEventListener("mouseup", (event) => {
		// Fermer le menu au clic en dehors de la zone
		if (
			!document
				.querySelector("#page-header .header__wrapper")
				.contains(event.target) &&
			document.querySelector("#page-header .header__wrapper") !== event.target
		) {
			scrollEnabled(true);
			pageHeader.classList.remove("page__header--open");
		}
	});
}

// Menu Dropdown : Action au clic
function menuItemDropdown() {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
}

// Bannière : Ouverture/Fermeture
function bannerClosing() {
	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");
		});
	}
}

// Bannière : Activation/désactivation du défilement horizontal
function bannerScrollingDetect() {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
}

// Data-popup : Action au clic
function popupInit() {
	const popups = document.querySelectorAll("[data-popup]");

	popups.forEach((popup) => {
		popup.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popup
			const thisPopupName = popup.dataset.popup;
			if (thisPopupName) {
				const thisPopupEl = document.querySelector(
					`.page__popup#${thisPopupName}`
				);
				thisPopupEl.classList.toggle("page__popup--open");
			}

			// mettre les vidéos des popups en pause
			const htmlVideoFromPopup =
				document.querySelectorAll(".page__popup video");
			if (htmlVideoFromPopup.length > 0) {
				htmlVideoFromPopup.forEach((video) => {
					video.pause();
				});
			}
		});
	});

	document.addEventListener("mouseup", (event) => {
		// si une popup est ouverte
		if (
			document.querySelectorAll(".page__popup.page__popup--open").length > 0
		) {
			// clic en dehors de la zone
			if (
				!document
					.querySelector(".page__popup .popup__wrapper")
					.contains(event.target) &&
				document.querySelector(".page__popup .popup__wrapper") !== event.target
			) {
				// fermer la popup
				document.querySelectorAll(".page__popup").forEach((popup) => {
					popup.classList.remove("page__popup--open");
				});

				// mettre les vidéos des popups en pause
				const htmlVideoFromPopup =
					document.querySelectorAll(".page__popup video");
				if (htmlVideoFromPopup.length > 0) {
					htmlVideoFromPopup.forEach((popupVideo) => {
						popupVideo.pause();
					});
				}
			}
		}
	});
}

// Data-toggle : Action au clic
function toggleInit() {
	const toggleListener = document.querySelectorAll("[data-toggle]");

	toggleListener.forEach((toggleButton) => {
		toggleButton.addEventListener("click", (event) => {
			// ouvrir/fermer l'accordéon
			let toggleData = toggleButton.dataset.toggle;
			if (toggleData) {
				toggleData = toggleData.split(",");
				let toggleTarget = toggleData.shift();
				if (toggleTarget) {
					// cible
					let toggleTargetEl = document.querySelector(`#${toggleTarget}`);
					if (toggleData) {
						toggleData.forEach(function (className) {
							className = className.trim();
							// ajouter/retirer les classes renseignés
							toggleTargetEl.classList.toggle(className);
						});
					} else {
						// ajouter/retirer la classe ".active"
						toggleTargetEl.classList.toggle("active");
					}
				}
			}
		});
	});
}

// Swiper : Activation des sliders
function allSwiperInit() {
	if (
		document.querySelectorAll(
			".section-archive-related-news .swiper .swiper-slide"
		).length > 0
	) {
		const swiperRelatedNews = new Swiper(
			".section-archive-related-news .swiper",
			{
				// Core parameters
				slidesPerView: "auto",
				speed: 1200,
				resizeObserver: true,
				// Modules
				modules: [Autoplay, Scrollbar],
				// Modules parameters
				autoplay: {
					delay: 3600,
					disableOnInteraction: true,
				},
				scrollbar: {
					el: ".section-archive-related-news .swiper-scrollbar",
					draggable: true,
				},
			}
		);
	}

	if (
		document.querySelectorAll(
			".section-hero-single-portfolio .swiper .swiper-slide"
		).length > 0
	) {
		const swiperHeroSinglePortfolio = new Swiper(
			".section-hero-single-portfolio .swiper",
			{
				// Core parameters
				slidesPerView: "auto",
				speed: 1200,
				loop: true,
				resizeObserver: true,
				// Modules
				modules: [Autoplay, Navigation, Parallax],
				// Modules parameters
				autoplay: {
					delay: 2400,
					disableOnInteraction: true,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				parallax: true,
			}
		);
	}
}

// Vivus : Animations au hover des svg ciblé par [data-vivus]
function allVivusInit() {
	const elementsToVivus = document.querySelectorAll("[data-vivus]");
	elementsToVivus.forEach((element) => {
		element.addEventListener("mouseenter", () => {
			new Vivus(element.querySelector("svg"), {
				type: "delayed",
				duration: 100,
			});
		});
	});
}

// GSAP -: Rafraîchissement du ScrollSmoother (plugin ScrollSmoother)
function gsapScrollSmootherRefresh() {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
}

// GSAP : Scroll vers une ancre (avec le plugin ScrollSmoother)
function gsapScrollTo() {
	// avec un [href="#..."]
	const scrollToAnchor = document.querySelectorAll("a[href^='#']");
	scrollToAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			let anchorHref = link.getAttribute("href");
			scrollSmooth.scrollTo(anchorHref, true);
		});
	});

	// avec un [data-scrollto]
	const scrollToData = document.querySelectorAll("[data-scrollto]");
	scrollToData.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData == "auto") {
				anchorData = window.innerHeight + window.scrollY;
			}
			scrollSmooth.scrollTo(anchorData, true);
		});
	});

	// au chargement
	let hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollSmooth.scrollTo(hashInUrl, true);
	}
}

// GSAP : Création d'élèments sticky (avec le plugin ScrollTrigger)
function gsapStickyElement() {
	const stickyWrapper = document.querySelector("[data-sticky]");

	if (stickyWrapper) {
		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 1024px)": () => {
				ScrollTrigger.create({
					trigger: stickyWrapper.firstElementChild,
					start: "center center",
					end: () =>
						`+=${
							stickyWrapper.offsetHeight -
							stickyWrapper.firstElementChild.offsetHeight
						}`,
					pin: true,
					pinSpacing: false,
					invalidateOnRefresh: true,
					// markers: true,
				});
			},
		});
	}
}

// GSAP : Découpage des textes (avec le plugin SplitText)
function gsapSplitText() {
	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			tag: "span",
			type: "lines, words", //, chars",
			linesClass: "line",
			wordsClass: "word",
			// charsClass: "letter",
		});
	});
}

// GSAP : Animations d'apparition (avec le plugin ScrollTrigger)
function gsapAnimations() {
	// Ajout/retrait de la classe --animated
	elementsToAnimatedFirst.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "-=50px +=100%",
			end: "bottom +=0%",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			// markers: true,
		});
	});

	// Ajout/retrait de la classe --animated
	setTimeout(() => {
		elementsToAnimatedSecond.forEach((_this) => {
			const delay = _this.getAttribute("data-animation-delay")
				? parseInt(_this.getAttribute("data-animation-delay"), 10)
				: 0;
			ScrollTrigger.create({
				trigger: _this,
				start: "-=50px +=100%",
				end: "bottom +=0%",
				onEnter: () => {
					setTimeout(() => {
						_this.classList.add("--animated");
					}, delay);
				},
				onLeaveBack: () => {
					_this.classList.remove("--animated");
				},
				// markers: true,
			});
		});
	}, 500);

	// au chargement
	let hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollSmooth.scrollTo(hashInUrl, true);
	}
}

// GSAP : Loader d'accueil (avec EasePack)
function gsapPreLoader() {
	// Chargement des fonctions GSAP préalables
	beforePreloader();

	// Lancement de l'animation de chargement
	let loaderTimeline = gsap.timeline();
	if (document.querySelector("body.home")) {
		loaderTimeline
			// animation
			.to("#page-preloader-content", {
				delay: 0.3,
				duration: 0.3,
				ease: "power2.out",
				opacity: 1,
			})
			.fromTo(
				"#page-preloader-background > *:first-child",
				{
					opacity: 0,
					transform: "translateY(20px) scale(.25)",
				},
				{
					duration: 0.6,
					ease: "power1.out",
					opacity: 1,
					transform: "translateY(0) scale(1)",
				}
			)
			.fromTo(
				"#page-preloader-background > *:last-child",
				{
					opacity: 0,
					transform: "rotate(-20deg)",
				},
				{
					duration: 0.6,
					ease: "power1.out",
					opacity: 1,
					transform: "rotate(0deg)",
				},
				"<.1"
			)
			.fromTo(
				"#page-preloader-delmat > *",
				{
					opacity: 0,
					transform: "translateY(10px)",
				},
				{
					stagger: 0.04,
					duration: 0.6,
					ease: "power1.out",
					opacity: 1,
					transform: "translateY(0)",
				},
				"<.5"
			)
			.fromTo(
				"#page-preloader-materiaux > *",
				{
					opacity: 0,
					transform: "translateY(20px)",
				},
				{
					stagger: 0.02,
					duration: 0.6,
					ease: "power3.out",
					opacity: 1,
					transform: "translateY(0)",
				},
				"<.3"
			)
			.to("#page-preloader-content", {
				duration: 0.6,
				ease: "power1.out",
				opacity: 0,
				transform: "translateY(-20px)",
			})
			.to("#page-preloader-wrapper", {
				duration: 0.6,
				ease: "power1.out",
				opacity: 0,
			})
			.set("#page-preloader", {
				visibility: "hidden",
			});
	} else {
		loaderTimeline
			// animation
			.to("#page-preloader-wrapper", {
				delay: 0.3,
				duration: 0.6,
				ease: "power2.out",
				opacity: 0,
			})
			.set("#page-preloader", {
				visibility: "hidden",
			});
	}
	// Functions succédentes
	loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.6);
}

// Global/GSAP : Actions précédant le Loader d'accueil
function beforePreloader() {
	scrollEnabled(false);
	gsapSplitText();
	gsapStickyElement();
}

// Global/GSAP : Actions suivant le Loader d'accueil
function afterPreloader() {
	scrollEnabled(true);
	gsapAnimations();
	gsapScrollTo();
}
